var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.getDeclinationComponent,{tag:"component",staticClass:"product-banner",class:_vm.getDeclinationClass,attrs:{"declination-data":_vm.declinationData}})}
var staticRenderFns = []

export { render, staticRenderFns }